import { styleConstants } from '@paywithextend/components'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { BudgetsFiltersBody } from 'src/components/BudgetsBoxWithFilters/BudgetsBoxWithFilters'
import BudgetsTable from 'src/components/BudgetsTable/BudgetsTable'
import FilterSection from 'src/components/FilterSection/FilterSection'
import NavAwayBox, { NavAwayProps } from 'src/components/NavAwayBox/NavAwayBox'
import TableEmptyState, {
  TableEmptyStateDesigns,
} from 'src/components/TableEmptyState/TableEmptyState'
import { useWindowScrollBottomHandler } from 'src/hooks'
import { CreditCardListModel } from 'src/models/creditCard.models'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { InfiniteScrollProps } from 'src/types'
import { css } from 'styled-components'

interface BudgetsBoxProps {
  className?: string
  budgets: CreditCardListModel[]
  isSlim: boolean
  defaultTitle: React.ReactElement
  isSnapshot?: boolean
  navAway?: NavAwayProps
  readOnly?: boolean
  clientHeight?: number
  infiniteScrollProps?: InfiniteScrollProps<BudgetsFiltersBody>
}

const BudgetsBox: React.FC<BudgetsBoxProps> = (props): React.ReactElement => {
  const showNewBudgetsTable = useSelector(
    selectFeatureFlaggerFromState,
  )?.show_new_budgets_table

  const handleScroll = useCallback((): void => {
    if (
      props.infiniteScrollProps !== undefined &&
      !props.infiniteScrollProps.loading &&
      !props.infiniteScrollProps.complete &&
      !showNewBudgetsTable
    ) {
      props.infiniteScrollProps.fetch?.(
        undefined,
        props.infiniteScrollProps.page !== undefined
          ? props.infiniteScrollProps.page + 1
          : 0,
      )
    }
  }, [
    props.infiniteScrollProps?.loading,
    props.infiniteScrollProps?.complete,
    props.infiniteScrollProps?.fetch,
    props.infiniteScrollProps?.page,
    showNewBudgetsTable,
  ])
  useWindowScrollBottomHandler(handleScroll)

  return (
    <NavAwayBox
      navAway={props.isSnapshot ? props.navAway : undefined}
      loading={props.infiniteScrollProps?.loading && !showNewBudgetsTable}
    >
      <FilterSection topLeftContent={props.defaultTitle} />
      <div
        css={css`
          background-color: ${styleConstants.colors.gray_lightest};

          ${!props.isSnapshot &&
          css`
            border-bottom-left-radius: ${styleConstants.borderRadius.box};
            border-bottom-right-radius: ${styleConstants.borderRadius.box};
            overflow: hidden;
          `}
        `}
      >
        {props.budgets.length > 0 && (
          <BudgetsTable
            budgets={props.budgets}
            isSlim={props.isSlim}
            infiniteScrollProps={props.infiniteScrollProps}
            clientHeight={props.clientHeight}
          />
        )}
        {props.budgets.length === 0 && props.infiniteScrollProps?.complete && (
          <TableEmptyState
            design={TableEmptyStateDesigns.AccountBudgets}
            readOnly={!!props.readOnly}
          />
        )}
      </div>
    </NavAwayBox>
  )
}

export default BudgetsBox
